<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://spareone.io">
              SPAREONE PLACE
            </a>
          </li>
          <li>
            <a href="https://spareone.io/profile">
              Profile
            </a>
          </li>
          <li>
            <a href="https://blog.spareone.io">
              Tistory Blog
            </a>
          </li>
          <li>
            <a href="https://blog.naver.com/spareone1">
              Naver Blog
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@ChangHyeon">
              Youtube
            </a>
          </li>
          <li>
            <a href="https://github.com/spareone1">
              Github
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Designed by
        <a href="https:///www.invisionapp.com" target="_blank" rel="noopener"
          >Invision</a
        >. Coded by
        <a href="https://binarcode.com" target="_blank" rel="noopener"
          >BinarCode</a
        >
        and
        <a href="https://www.creative-tim.com" target="_blank" rel="noopener"
          >Creative Tim</a
        >.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
